var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/icons/quick-msg",
    transform: "translate(3.000000, 10.000000)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93333333,12.5714286 C8.42476895,15.4930001 10.2439937,16.9295803 13.1830425,18.3548366 L13.1830425,23.6299315 C13.1830425,23.7654356 13.2631852,23.8912308 13.3918772,23.9556762 C13.4507162,23.9853661 13.5156419,24 13.5801329,24 C13.6562177,24 13.7324475,23.9793156 13.7983877,23.9386502 L20.1557472,20.0171901 C20.4129864,20.0297134 20.6537044,20.0423773 20.8989149,20.0423773 C28.3681276,20.0423773 34,15.7342448 34,10.0215404 C34,4.30813248 28.3681276,0 20.8989149,0 C17.164526,0 13.8893996,1.07699794 11.5477256,2.86824223 L17.2310459,2.86824223 L11.9,12.5714286 L7.93333333,12.5714286 Z",
    id: "Stroke-3",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4,5.71428571 L13.6,5.71428571",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L10.2,8",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4,10.2857143 L9.06666667,10.2857143",
    id: "Stroke-9"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-10",
    fill: "#000",
    cx: 18.1333333,
    cy: 10.2857143,
    rx: 1.13333333,
    ry: 1.14285714
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-10",
    fill: "#000",
    cx: 22.6666667,
    cy: 10.2857143,
    rx: 1.13333333,
    ry: 1.14285714
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-10",
    fill: "#000",
    cx: 27.2,
    cy: 10.2857143,
    rx: 1.13333333,
    ry: 1.14285714
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQm);
export default __webpack_public_path__ + "static/media/qm.e39f807203aad61d6e3ec3b608214c0d.svg";
export { ForwardRef as ReactComponent };